import React from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import { useAuth } from "../../hooks/useAuth";
import GoTODashboard from '../../components/button/GoTODashboard';

const Demo = () => {
  const { setIsSidebarOpen, isSidebarOpen } = useAuth();

  return (
    <div className='max-w-[1920px] mt-[100px] m-auto flex'>
      <div className='hidden sm:block'>
        <Sidebar />
      </div>
      <div className={`${isSidebarOpen ? "sm:ml-[300px]" : "sm:ml-[80px]"} w-full flex flex-col justify-center items-center transition-width duration-300 p-4`}>
    
        <div className='w-full max-w-[80%] flex justify-center items-center'>
          {/* Lazy-loaded Video */}
          <video
            className='w-full rounded-lg shadow-lg'
            controls
            preload="none"
            src='/NewDemoVideo.mp4'
            autoPlay={true}
            muted // Add this attribute
            alt='Demo Video'
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  )
}

export default Demo